/* eslint-disable import/no-anonymous-default-export */
export default [
  {
    title: "weather finder",
    imgUrl: "./assets/weatherfinder.png",
    imageAlt: "Screenshot of the Weather Finder app interface",
    stack: ["JavaScript", "Html", "CSS", "API Database"],
    link: "https://github.com/itosam/weatherfinder",
  },
  {
    title: "Be@rbrick & Mortar",
    imgUrl: "./assets/be@rbrick&mortardemo.gif",
    imageAlt: "Animated demo of the Be@rbrick and Mortar app",
    stack: ["React", "Bootstrap", "Ruby on Rails", "PostgreSQL"],
    link: "http://github.com/itosam/phase-5-project",
  },
  {
    title: "Game Invader",
    imgUrl: "./assets/gameinvaderdemo.gif",
    imageAlt: "Animated demo of the Game Invader app",
    stack: ["React", "Bootstrap", "Ruby", "SQLite"],
    link: "https://github.com/itosam/phase-3-project",
  },
  {
    title: "Slate Movie App",
    imgUrl: "./assets/movieappdemo.gif",
    imageAlt: "Animated demo of the Slate Movie App",
    stack: ["React", "Bootstrap", "JSON Database"],
    link: "https://itosam.github.io/movieapp/",
  },
  
];
